import CAROUSEL1 from 'images/MMModal/carousel_1.svg'
import CAROUSEL2 from 'images/MMModal/carousel_2.svg'
import CAROUSEL3 from 'images/MMModal/carousel_3.svg'

export const MODALS = [
  {
    title: 'Drift Help',
    description: 'Create and Manage Articles',
    copy:'With an easy article editor and manager - you can focus on the content and leave the visuals to us.',
    gradientStart:'#C86DD7',
    gradientEnd:'#3023AE',
    svg: CAROUSEL1
  },
  {
    title: 'Drift Help',
    description: 'Automate Support with Driftbot',
    copy:'Help others, help themselves. With your custom branded, searchable help center, your visitors will be able to find the answers they need.',
    gradientStart:'#FAD961',
    gradientEnd:'#F76B1C',
    svg: CAROUSEL2
  },
  {
    title: 'Drift Help',
    description: 'Share Your Own Public Help Center',
    copy: 'Driftbot will search your help center and share relevant links at the beginning of a conversation.',
    buttonCopy:'Try it out',
    closeOnButtonClick: true,
    gradientStart:'#0075FF',
    gradientEnd:'#0006A7',
    svg: CAROUSEL3
  },
]

export const VIEWED_MM_MODAL_ON_KB = 'viewedJuneMMModalOnHelpCenter'